module.exports = __webpack_public_path__ + "static/media/large_balancing_tube_lt.3b7c7a1b.svg";